import { AppProvider } from '@!/providers'
import Ranking from '@!/Store/Ranking/containers/Ranking'

const RankingApp = (props) => {
  return (
    <AppProvider>
      <Ranking rankingType={props.ranking_type} searchTags={props.search_tags} />
    </AppProvider>
  )
}

export default RankingApp
